import { LinearGradient } from 'expo-linear-gradient';
import React from 'react';
import { Animated, Pressable, StyleSheet, Text, View } from 'react-native';
import { useAnalytics } from 'services/analytics/useAnalytics';
import { Platform } from 'utils/platform';

import FocusView from 'components/FocusView';
import SolidPlay from 'components/Icons/SolidPlay';
import { WebDiv } from 'components/WebDiv';

export const Cancel: React.FC<any> = ({
  useTVFocus = false,
  mini = false,
  onPress,
  programTitle,
  programEpTitle,
  ...rest
}) => {
  const analytics = useAnalytics();
  const [isFocused, setIsFocused] = React.useState(false);
  const baseOnFocus = () => (Platform.isAndroidTV && useTVFocus ? setIsFocused(true) : null);
  const baseOnBlur = () => (Platform.isAndroidTV && useTVFocus ? setIsFocused(false) : null);

  const onFocus = () => {
    baseOnFocus();
    rest.onBtnFocus?.();
  };

  const onBlur = () => {
    baseOnBlur();
    rest.onBtnBlur?.();
  };

  const onPressProxy = (...args: any) => {
    onPress(...args);

    analytics.triggerMediaAutonextCancelActionEvent({
      programTitle: programTitle,
    });
  };

  return (
    <WebDiv className="rounded-6">
      <Pressable
        id="linearGradientButton"
        onFocus={onFocus}
        onBlur={onBlur}
        onPress={onPressProxy}
        style={{
          height: mini ? 32 : 40,
          borderWidth: 2,
          borderColor: isFocused ? 'red' : '#2240FF',
          borderStyle: 'solid',
          borderRadius: styles.gradient.borderRadius,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#00000088',
          paddingHorizontal: 20,
        }}
        {...rest}>
        <Text style={{ fontFamily: 'system-ui', fontSize: mini ? 14 : 16, color: '#FFFFFF' }}>
          Cancelar
        </Text>
      </Pressable>
    </WebDiv>
  );
};

export const Next = React.forwardRef<any, any>(
  ({ useTVFocus = false, mini = false, onPress, programTitle, programEpTitle, ...rest }, ref) => {
    const analytics = useAnalytics();
    const [isFocused, setIsFocused] = React.useState(false);
    const baseOnFocus = () => (Platform.isAndroidTV && useTVFocus ? setIsFocused(true) : null);
    const baseOnBlur = () => (Platform.isAndroidTV && useTVFocus ? setIsFocused(false) : null);

    const onFocus = () => {
      baseOnFocus();
      rest.onBtnFocus?.();
    };

    const onBlur = () => {
      baseOnBlur();
      rest.onBtnBlur?.();
    };

    const onPressProxy = (...args: any) => {
      onPress(...args);

      analytics.triggerMediaAutonextImmediateActionEvent({
        programTitle: programTitle
      });
    };

    const animatedWidth = React.useRef(new Animated.Value(0)).current;

    React.useEffect(() => {
      // Animate the width from 0 to 100% over 10 seconds
      Animated.timing(animatedWidth, {
        toValue: 1, // Representing 100% as 1
        duration: 10000, // 10 seconds
        useNativeDriver: false,
      }).start();
    }, [animatedWidth]);

    const interpolatedWidth = animatedWidth.interpolate({
      inputRange: [0, 1],
      outputRange: ['0%', '100%'],
    });

    return (
      <WebDiv className="rounded-6">
        <FocusView>
          <View
            style={{
              overflow: 'hidden',
              backgroundColor: '#FFFFFF66',
              borderRadius: styles.gradient.borderRadius,
            }}>
            <Animated.View style={[styles.gradient, { width: interpolatedWidth }]}>
              <LinearGradient
                end={{ x: 0, y: 0 }}
                start={{ x: 0, y: 1 }}
                colors={['#00AD5C', '#6DFFBC']}
                style={[styles.gradient, { width: '100%' }]}
              />
            </Animated.View>

            <Pressable
              id="linearGradientButton"
              ref={ref}
              onFocus={onFocus}
              onBlur={onBlur}
              onPress={onPressProxy}
              style={{
                height: mini ? 32 : 40,
                borderWidth: 2,
                borderColor: isFocused ? 'red' : 'transparent',
                borderStyle: 'solid',
                borderRadius: styles.gradient.borderRadius,
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'transparent',
                flexDirection: 'row',
                paddingHorizontal: 20,
                gap: 4,
              }}
              hasTVPreferredFocus
              {...rest}>
              <SolidPlay color="black" />
              <Text
                style={{
                  fontFamily: 'system-ui',
                  fontSize: mini ? 14 : 16,
                  fontWeight: 'bold',
                  color: '#070d31',
                }}>
                Próximo Episódio
              </Text>
            </Pressable>
          </View>
        </FocusView>
      </WebDiv>
    );
  }
);

const styles = StyleSheet.create({
  gradient: {
    position: 'absolute',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 25,
    overflow: 'hidden',
  },
});
